// Firebase is kept only for Performance Monitoring. Its Analytics stream was replaced by the
// GA4 "First Round" property (analytics/ga4.ts), so nothing here logs analytics events.
import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";

import { env } from "@/client/config/env";

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const performance = getPerformance(app);

export { performance };
